export default __webpack_public_path__ + "static/benifitImage1-d7518a9dbfb0b402a38f234b672bf217.webp";